import React from 'react'
import { Link } from 'react-router-dom';
import About_1 from '../../../assets/images/about/about-four.jpg';

const About = () => {
    return (
        <>
            <div className="about-section-four">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-lg-6">
                            <div
                                className="about-image-four animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <img src={About_1} alt="about-image" />
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6">
                            <div className="about-info-four">
                                <div className="heading-box">
                                    <span
                                        className="sub-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                    >
                                        About Us
                                    </span>
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="200ms"
                                    >
                                        We are building a future together, Be with us
                                    </h2>
                                </div>
                                <p
                                    className="lead animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews. Iterative approaches to collaborative .
                                </p>
                                <Link to="#" className="btn btn-secondary btn-theme">
                                    About Us <span>+</span>
                                </Link>
                                <div
                                    className="about-counter-four animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="600ms"
                                >
                                    <div className="counter-box-four">
                                        <h4>
                                            <span className="counter">1962</span> <span> +</span>
                                        </h4>
                                        <p>Companies analyzed</p>
                                    </div>
                                    <div className="counter-box-four">
                                        <h4>
                                            <span className="counter">1856</span> <span> +</span>
                                        </h4>
                                        <p>Strategies planned</p>
                                    </div>
                                    <div className="counter-box-four">
                                        <h4>
                                            <span className="counter">18</span> <span> k</span>
                                        </h4>
                                        <p>Happy Customers</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}

export default About
